import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";

const { fontSize } = typographyStyles;
const { colors, breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs } = breakpoints.BreakpointNames;

const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[700];

const MAX_HEIGHT_OF_DROPDOWN = "336px";

export const rootCss = {
  display: "block",
};

export const buttonSizing = {
  padding: "16px",
  maxHeight: "48px",
  [mediaQuery.upTo(xs)]: {
    padding: "8px",
  },
};

export const buttonWithPopOutCss = {
  ...buttonSizing,
  "span:last-child": {
    span: {
      svg: {
        width: "0.85rem",
        path: {
          strokeWidth: "4px",
        },
      },
    },
  },
};

export const scrollableContainerCss = {
  maxHeight: MAX_HEIGHT_OF_DROPDOWN,
  overflowY: "auto",
};

export const dropdownListCss = (isArticlePrintDisabled) => ({
  listStyle: "none",
  margin: isArticlePrintDisabled ? "0" : "8px 0",
  padding: "0",
});

export const dropdownWrapperCss = (isArticlePrintDisabled) => ({
  ...scrollableContainerCss,
  ...dropdownListCss(isArticlePrintDisabled),
});

export const sharedOptionCss = {
  borderRadius: "2px",
  color: grey,
  fontSize: fontSize.textM,
  fontWeight: "normal",
  justifyContent: "start",
  lineHeight: "150%",
  padding: "8px 16px 8px 24px",
  width: "100%",

  "&:hover, &:focus-visible": {
    color: greyDark,
    background: greyDarkWithOpacity,
  },
  "&:hover:not([disabled])::before": {
    backgroundColor: "transparent",
    opacity: "1",
  },
};
